import React, { useState } from "react";
import {
  Tab,
  TabContent,
  TabContentGroup,
  TabGroup,
  TabMenu,
} from "@americanexpress/dls-react";
import PaymentInputForm from "./PaymentInputForm";

const PaymentForm = (props) => {
  const { vPayment, go, t } = props;
  var initialDatav = {};
  var initialDatago = {};

  if (props.data.functions !== undefined) {
    props.data.functions.map((fun) => {
      if (fun.functionName === "American Express vPayment™") {
        initialDatav = {
          fundingAcc: fun.fundingBillingAccount,
          maxToken: fun.maxLimitPerToken,
          dailyToken: fun.dailyNumberOfTokens,
          maxSpend: fun.maxSpendPerDay,
          thresholdAmount: fun.thresholdAmount,
          recepient: fun.notificationRecipient,
        };
      }
      if (fun.functionName === "American Express Go™") {
        initialDatago = {
          fundingAcc: fun.fundingBillingAccount,
          maxToken: fun.maxLimitPerToken,
          dailyToken: fun.dailyNumberOfTokens,
          maxSpend: fun.maxSpendPerDay,
          thresholdAmount: fun.thresholdAmount,
          recepient: fun.notificationRecipient,
        };
      }
    });
  }

  const currentTab = vPayment ? "tab-1" : "tab-2";
  const [vPaymentData, setvPaymentData] = useState(initialDatav);
  const [goData, setGoData] = useState(initialDatago);
  // const [vCompleted, setVCompleted] = useState(false);
  // const [goCompleted, setGoCompleted] = useState(false);

  return (
    <TabGroup defaultSelectedTab={currentTab}>
      <TabMenu>
        {vPayment && <Tab id="tab-1">{t("products.functname9")}</Tab>}
        {go && <Tab id="tab-2">{t("products.functname12")}</Tab>}
      </TabMenu>
      <TabContentGroup>
        {vPayment && (
          <TabContent labelledBy="tab-1">
            <PaymentInputForm
              data={vPaymentData}
              tb="1"
              dataChange={(data, complete) => {
                setvPaymentData({ ...vPaymentData, ...data });
                //setVCompleted(complete);
                go
                  ? props.dataChange({
                      vPayment: vPaymentData,
                      goExpress: goData,
                      completed: complete,
                    })
                  : props.dataChange({
                      vPayment: vPaymentData,
                      completed: complete,
                    });
              }}
            />
          </TabContent>
        )}
        {go && (
          <TabContent labelledBy="tab-2">
            <PaymentInputForm
              data={goData}
              tb="2"
              dataChange={(data, complete) => {
                setGoData(data);
                //setGoCompleted(complete);
                vPayment
                  ? props.dataChange({
                      vPayment: vPaymentData,
                      goExpress: goData,
                      completed: complete,
                    })
                  : props.dataChange({
                      goExpress: goData,
                      completed: complete,
                    });
              }}
            />
          </TabContent>
        )}
      </TabContentGroup>
    </TabGroup>
  );
};

export default PaymentForm;
